export enum PricesTypes {
    wholesale,
    discounted_wholesale,
}

export interface PriceRule {
    price: string | null;
    type: PricesTypes;
    dataTest: string;
}
